import React from "react";
import Image from "next/image";
const Phone = () => {
  return (
    <div className="flex justify-center mt-[96px] h-full w-full max-w-[90rem] my-2 relative">
      <div className="lg:w-[1120.1px] lg:h-[651px] w-full h-[209px] relative">
        <Image
          loading="lazy"
          layout="fill"
          src="/projects/iPillion/bg-phone.png"
          quality={100}
        />
      </div>
    </div>
  );
};

export default Phone;
